(function() {
    /* jshint validthis: true */
    "use strict";

    var lang = lang || document.documentElement.lang;
    var scrollTop = 0;
    var footerProp = {};
    var sideMenu, headBar;
    var sideMenuH = 0;
    var sideMenuOffsetTop = 0;
    var sideMenuScrollTop = 0;
    var sideMenuScrollLimit = 0;
    var headBarH = 0;
    
    function initParentCatSlider(){
        var $nav = $(".shop-parent-nav");
        if ($nav.length !== 0) {
//            $nav.on("init", function(event, slick) {
//                $nav.slick("slickGoTo", $nav.slick("slickCurrentSlide"), true);
//            });
            initSlick($nav, {}, {
                infinite: true,
                slidesToShow: 8,
                slidesToScroll: 4,
                variableWidth: true,
                arrows: false,
                dots: false,
                autoplay: false,
                speed: 500,
                responsive: [
                    {
                        breakpoint: 1380,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 1125,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 865,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 390,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    }
    
    function openTooltip(){
        var t = $(this);
        var id = t.attr("data-id");
        
        $(".tooltip-" + id).addClass("active");
        $("#blackout").fadeIn().css("z-index", "50");
    }
    
    function closeTooltip(){
        var t = $(this);
        
        $("#blackout").fadeOut();
        t.closest(".tooltip").removeClass("active");
    }
    
    function slideToCat(){
        var t = $(this);
        var id = t.attr("data-id");
        
        $(".side-nav-btn.active").removeClass("active");
        t.addClass("active");
        
        $('html,body').animate({
            scrollTop: $('.shop-product-ctn[data-categoryId = ' + id + ']').offset().top - 20
        }, 500);
    }
    
    function stickyMenu() {
        if (Math.floor(winY - scrollTop) !== 0 && !modeResp) {
            scrollTop = window.pageYOffset;
            sideMenuScrollTop = scrollTop + headBarH - sideMenuOffsetTop;

            if (sideMenuScrollTop > 0) {
                if (scrollTop >= sideMenuScrollLimit) {
                    removeClass(sideMenu, "sticky");
                    addClass(sideMenu, "sticky-bottom");
                } else {
                    addClass(sideMenu, "sticky");
                    removeClass(sideMenu, "sticky-bottom");
                }
            } else {
                removeClass(sideMenu, "sticky");
                removeClass(sideMenu, "sticky-bottom");
            }
        }

        rAF(stickyMenu);
    }
    
    function fetchSizes() {
        footerProp = getFooterProp();
        headBarH = winW > 1280 ? 0 : headBar.clientHeight;
        sideMenuOffsetTop = getElementOffset(sideMenu).top;
        sideMenuH = getElementHeight(sideMenu);
        var marginBottom = winW > 1024 ? 80 : 30;
        sideMenuScrollLimit = footerProp.top - sideMenuH - headBarH - marginBottom;
    }
    
    function getFooterProp() {
        return {
            height: qs(".footer").clientHeight,
            top: getElementOffset(qs(".footer")).top
        };
    }
    
    function getElementHeight(el) {
        if (el) {
            return el.clientHeight;
        } else {
            return 0;
        }
    }
    
    // Pre-initiate
    DOMInit("interactive", function(e) {
        initParentCatSlider();
        
        bindEvent(".side-nav-btn", "click", slideToCat);
        bindEvent(".tooltip-trigger", "click", openTooltip);
        bindEvent(".close-tooltip", "click", closeTooltip);
    });
    
    // Initiate
    DOMInit("complete", function(e) {
        headBar = qs(".header .header-bottom");
        sideMenu = qs(".side-nav-moving");
        if (headBar && sideMenu) {
            fetchSizes();
            rAF(stickyMenu);
            window.addEventListener("resize", fetchSizes);
        }
    });

})();